import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ScreenContainer, ContentFrame } from '@pinwheel/origami';
import TemplateForm from '../../LinkApiRouter/components/TemplateForm/TemplateForm';
import ModalHeader from '../../components/ModalHeader';
import { useOpts } from '../../context';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { EventAction, EventType } from '../../types/events';
import { selectCurrentSource, selectLastSource, } from '../../state/slices/slice-segment';
import { selectHasAttemptedDDS } from '../../state/slices/slice-link-api';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var UserNameEntry = function () {
    var _a = useDDFormContext(), isEditFlow = _a.isEditFlow, setUserName = _a.setUserName, goBack = _a.goBack, userName = _a.userName;
    var getLocalizedString = useGetLocalizedString();
    var fireUnifiedEvent = useOpts().fireUnifiedEvent;
    var navigate = useLinkNavigate();
    var currentSource = useSelector(selectCurrentSource);
    var lastSource = useSelector(selectLastSource);
    var hasAttemptedDDS = useSelector(selectHasAttemptedDDS);
    var handleSubmit = function (value) {
        setUserName(value.user_name);
        fireUnifiedEvent(EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT, {
            action: EventAction.CONTINUE,
            entry_point: lastSource,
            source: currentSource,
        });
        if (isEditFlow || !hasAttemptedDDS) {
            navigate('/dd-form/amount-selection');
        }
        else {
            navigate('/dd-form/confirmation-screen');
        }
    };
    var userField = useMemo(function () { return ({
        key: 'user_name',
        label: getLocalizedString('FULL_NAME'),
        fieldType: 'text',
        required: true,
        fieldSubtype: 'plaintext',
        placeholder: 'Jordan Doe',
    }); }, [getLocalizedString]);
    return (React.createElement(ScreenContainer, { "data-testid": "ScreenContainer" },
        React.createElement(ModalHeader, { title: getLocalizedString('FULL_NAME'), onBack: goBack }),
        React.createElement(ContentFrame, { "data-testid": "UserNameForm" },
            React.createElement(TemplateForm, { fieldConfigs: [userField], initialValues: { user_name: userName }, onSubmit: handleSubmit, submitButtonEventId: "DDForm-userName" }))));
};
export default UserNameEntry;
